<template>
  <div>

    <div @drop="onDropBom" @dragover.prevent>
      <vxe-grid ref="xGrid" :cell-class-name="cellClassName" class="mytable-style" v-bind="gridOptions"
        :loading="loading" :sync-resize="selectTab" @edit-disabled="editDisabledEvent" show-header-overflow
        @checkbox-change="checkboxChangeEventBom" @checkbox-all="checkboxChangeEventBom"
        @edit-actived="editActivedEvent" :cell-style="{ padding: '3px', 'font-size': '12px', 'line-height': '16px ' }">

        <template #toolbar>
          <div style="display: flex;gap: 10px; margin: 10px 0;">
            <div>
              <el-button class="btn btn1" icon="el-icon-circle-plus-outline" @click="addNewData('searchAddRedLine')"
                :disabled="getAddPriv()">{{ $t("message.button.add") }}
              </el-button>
              <el-button class="btn btn2" icon="el-icon-delete" @click="removeRedLineRow" :disabled="getRemovePriv()">{{
                $t("message.button.delete") }}
              </el-button>
              <el-button class="btn btn3" icon="el-icon-help" @click="unDoRedLineRow" :disabled="getRemovePriv()">{{
                $t("message.button.Undo") }}
              </el-button>
              <el-button class="btn btn4" icon="el-icon-circle-close" @click="copyItems" :disabled="getAddPriv()">{{
                $t("message.button.copy")
                }}
              </el-button>
            </div>

            <div style="margin-left: auto;">
              <el-button class="btn btn7" icon="el-icon-document-checked" @click="readLineUpdate"
                :disabled="getAddPriv()">{{
                  $t("message.button.save") }}
              </el-button>
              <el-button class="btn btn8" icon="el-icon-circle-close" @click="redLineBomCloseSave"
                :disabled="getAddPriv()">{{
                  $t("message.button.cancel") }}
              </el-button>
            </div>
          </div>

          <!-- <el-button class="btn btn7" icon="el-icon-document-copy" @click="setAlt">
                  添加替代料</el-button> -->

        </template>

        <template #cascadeShow="{ row }">
          {{ row[index] }}
        </template>
        <template #cascadeEdit="{ row }">
          <el-select v-model="row[index]" filterable remote :placeholder="$t('message.placeholder.search')"
            @keyup.native.enter="getUserkeywords">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </template>

        <template #getDynamic="{ row, columnIndex, column }">
          <span v-for="(item, index) in getDynamicData(
            row,
            columnIndex - 1,
            column
          )" class="showLink" :key="index" :title="item.label" @click="clax(item)">
            {{ item.label }}</span>
        </template>

        <template #bottom>
          <Bottom-Tips :data="{ selectRecords: selectRecords.length, totalRecords: totalRecordsBom }" />
        </template>
      </vxe-grid>
    </div>
    <el-dialog v-dialogDrag v-if="searchAddRedLine" class="searchAddRedLineList" :title="$t('message.title.add')"
      :visible.sync="searchAddRedLine" :close-on-click-modal="false" :close-on-press-escape="false">
      <searchRedLineAdd :creatBy="creatBy" @listDbClick="addRedLineList" :departmentList="departmentList">
        <!-- <div>
          <el-button size="small" type="primary" icon="el-icon-edit-outline" @click="creatNew = true">{{
            $t("message.button.create") }}</el-button>
        </div> -->
      </searchRedLineAdd>
    </el-dialog>
    <el-dialog v-dialogDrag v-if="creatNew" class="searchAddBomList" :title="$t('message.title.add')"
      :visible.sync="creatNew" :close-on-click-modal="!creatNew">

      <Create :creatBy="creatBy" :saveUrl="saveTableUrl" :baseClass="baseClass_" @addToList="creatNewModel"
        @closeCreateNew="closeCreateNew" :departmentList="departmentList"></Create>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import BottomTips from "@/components/bottomTips.vue";
import searchRedLineAdd from "@/components/searchAdd.vue";
import { getNewRedLineTableContentData, getNewTableTitleData, gridOptions, setListEntry } from "./affectItemConfig";
import { mapState, mapMutations } from 'vuex';
import Create from "@/components/common/Create.vue";

export default {
  data() {
    return {
      searchAddRedLine: false,
      selectRecords: [],
      totalRecordsBom: "",


      loading: false,
      totalRecordsBom: "",
      selectTab: "123",
      creatBy: "BOM",
      creatNew: false,
      baseClass_: "",
      saveTableUrl: "",

      removeBtnPriv: false,
      addTableListPriv: false,
      gridOptions: {
        ...gridOptions,
        treeConfig: {},
        editConfig: {
          trigger: "dblclick",
          mode: "row",
          showIcon: false,
          activeMethod: this.activeRowMethod,
          showStatus: true,
        },
      },
    }
  },
  components: { BottomTips, searchRedLineAdd, Create },

  props: {
    itemInfo: Object,
    changePrivs: Object
  },
  created() {
    this.loadUserPriv();
    this.getBaseId();
    this.getData();
  },
  computed: {

    ...mapState({
      pageChanged: (state) => state.pageChanged,
      activeName: (state) => state.activedTabInHome,
      objId: (state) => state.objectId,
      change_info: (state) => state.change_info,
      changeObjId: (state) => {
        const { id: changeId, classId: changeClassId, subClassId: changeSubClassId } = state.objectId
        return {
          changeId, changeClassId, changeSubClassId
        }
      }
    }),

  },
  methods: {
    ...mapMutations([
      'setPageChanged',
      'setPageRefresh',
      'replaceShowingTabsInHome',
      'setActivedTabInHome'
    ]),

    getBaseId() {
      console.log(this.$store.state);
      if (this.objId.classId == 10410) {
        (this.baseClass_ = "501"),
          (this.saveTableUrl = "/pmdm/technology/saveTechnologyP1P2P3");
      } else {
        (this.baseClass_ = "101"),
          (this.saveTableUrl = "/pmdm/items/saveItemP1P2P3");
      }
    },

    getAddPriv() {
      const { add = false } = this.changePrivs;
      return !add || !this.addTableListPriv
    },
    getRemovePriv() {
      const { add = false } = this.changePrivs;
      return !add || !this.removeBtnPriv
    },
    getDynamicData(row, columnIndex, column) {
      const nCol = this.gridOption2.columns[columnIndex + 1].uiType;
      const options =
        this.gridOption2.columns[columnIndex + 1].editRender.options;

      const val = row[column["field"]];

      if (nCol === 3) {
        return options.filter((i) => i.value === val || i.label === val);
      } else {
        return !val
          ? []
          : options.filter(
            (i) => val.includes(i.value) || val.includes(i.label)
          );
      }
    },

    activeRowMethod({ row, rowIndex }) {
      //console.log(this.childsTable);
      //console.log(row);
      if (row.disable) {
        return false;
      }
      return true;
    },

    loadUserPriv(row) {
      const isSuperAdmin = this.$store.state.isSuperAdmin;
      const privList = this.getUserContextPriv()
        .filter((i) => i.classId == this.objId.subClassId)
        .map((j) => j.type);
      this.addTableListPriv = isSuperAdmin || privList.includes(3);
      this.removeBtnPriv = isSuperAdmin || privList.includes(4);
    },



    editActivedEvent({ row, columnIndex, column }) {
      this.setPageChanged({ name: this.componentname, isChanged: true })
      const nCol = this.gridOptions.columns[columnIndex];
      if (nCol.listType === 3) {
        axios
          .get(
            "pmdm/admin/list/getEnabledListEntryByListId?listId=" + nCol.listId
          )
          .then((res) => {
            nCol.editRender.options = res.data.object.listEntries.map((i) => ({
              value: i.listId + "_" + i.entryId,
              label: i.entryValue,
            }));
          });
      }
    },
    editDisabledEvent({ row, column }) {
      alert(this.$t("message.error.noEdit"));
    },
    checkboxChangeEventBom({ records }) {
      this.selectRecords = records;
    },

    async getData(row) {
      console.log(this.itemInfo);
      if (JSON.stringify(this.itemInfo) === "{}") {
        return
      }
      const { classId } = this.itemInfo;
      const baseId = Number(classId.toString().substring(0, 3))
      const listMap = new Map([
        [501, { url: `/pmdm/technology/loadTabl`, tableId: 81 }],
        [101, { url: `pmdm/items/loadTable`, tableId: this.Global.redLineBomTableId }]
      ])
      const { tableId, url } = listMap.get(baseId)

      const obj = { ...this.itemInfo, tableId };


      const { data } = await this.$http.get(`${url}${this.params(obj)}`);
      const { columnInfo, rows, seekId, saveColumns = [] } = data.object.table
      const { listIds, listTypes, uiTypes, listEntries } = columnInfo;

      const lisE = setListEntry({ listIds, listTypes, uiTypes, listEntries }, rows);
      this.departmentList = Object.entries(lisE[10001]).map(i => {
        const [value, label] = i
        return { value, label }
      })

      this.gridOptions.columns = getNewTableTitleData(columnInfo);

      const systemName = window.sessionStorage.getItem("systemName");
      if (systemName.indexOf("奥斯汀") != -1) {
        let quantity = 3;
        let proUnit = 5;
        for (let k = 0; k < this.gridOptions.columns.length; k++) {
          if (
            this.gridOptions.columns[k].attid == this.Constants.itemBOMQty
          ) {
            quantity = this.gridOptions.columns[k].field;

            this.gridOptions.editRules[quantity] = [
              { required: true, message: "必须填写" },
            ];
          }
          if (
            this.gridOptions.columns[k].attid ==
            this.Constants.itemBOMMultilist01
          ) {
            proUnit = this.gridOptions.columns[k].field;

            this.gridOptions.editRules[proUnit] = [
              { required: true, message: "必须填写" },
            ];
          }
        }

      }

      this.cols = columnInfo.ids;
      this.gridOptions.data = getNewRedLineTableContentData(rows, columnInfo);

      let columnsIndex = this.gridOptions.columns.findIndex(i => i.attid === 1003001);
      this.index = this.gridOptions.columns[columnsIndex].field;
      this.gridOptions.columns[columnsIndex].slots = {
        default: "cascadeShow",
        edit: "cascadeEdit"
      };

      this.loading = false;
    },
    cellClassName({ row, rowIndex, column, columnIndex }) {
      if (row.redText) {
        for (var i = 0; i < row.redText.length; i++) {
          if (columnIndex == row.redText[i]) {
            return "col-red-text";
          }
        }
      } else if (row.redLine) {
        for (var i = 0; i < row.redLine.length; i++) {
          if (columnIndex == row.redLine[i]) {
            return "col-red";
          }
        }
      } else {
        return "";
      }
    },


    onDropBom() {
      const vm = this;
      if (!this.addPrivBtn1 || !this.addTableListPriv) {
        return;
      }
      const fieldData = this.$store.state.dragMenu;
      const query = this.$route.query;
      const classId = Number(query.classId.slice(0, 3));
      if ((fieldData.type !== 101 && fieldData.type !== 501) || fieldData.type !== classId) {
        return;
      }
      const row = [{
        id: fieldData.id,
        itemNumber: fieldData.name,
        quantity: '1',
        department: null
      }];

      //根据变更单的classid判断发送数据的名称和路径
      if (this.objId.classId == 10410) {
        this.addTechnologyRedLineList(row);
      } else {
        let insertBom = row.map((i) => {
          return {
            "childId": i.id,
            "1003001": i.itemNumber,
            "itemId": this.itemInfo.id,
            "1003003": i.quantity,
          };
        });
        // let systemName = window.sessionStorage.getItem("systemName");
        // if (systemName.indexOf("奥斯汀") != -1) {
        //   insertBom = row.map((i) => {
        //     return {
        //       "childId": i.id,
        //       "1003001": i.itemNumber,
        //       "itemId": this.itemInfo.id,
        //       "1003003": i.quantity,
        //       "1003078": i.department.join(";"),
        //     };
        //   });
        // }
        var updateBomData = {
          //post更改的值
          tableId: this.Global.redLineBomTableId,
          changeObjId: { ...this.objId },
          itemObjId: {
            id: this.itemInfo.id,
            classId: this.itemInfo.classId,
            subClassId: this.itemInfo.subClassId,
            version: this.itemInfo.version,
          },
          insertBom: insertBom,
        };
        axios
          .post("/pmdm/items/saveTable", updateBomData)
          .then(res => {
            if (res.data.code == 200) {
              this.$message({
                message: res.data.message,
                type: "success",
              });
              this.closeCreateNew();
              this.$emit('reloadPage')
               this.getData();
            }
          })
          .catch(function (error) {
          });
      }
    },

    copyItems() {
      let items = this.$refs.xGrid.getCheckboxRecords().map(i => ({ id: i.itemId, itemNumber: i[0] }));
      items = items.reduce((pre, cur) => {
        const arr = pre.map(i => i.id);
        !arr.includes(cur.id) && pre.push(cur)
        return pre
      }, [])
      this.$store.commit('setCopyItems', items)
      this.$message.success('复制成功');
    },
    addRedLineList(row) {
      //添加
      if (row) {
        //根据变更单的classid判断发送数据的名称和路径
        if (this.objId.classId == 10410) {
          this.addTechnologyRedLineList(row);
        } else {
          let systemName = window.sessionStorage.getItem("systemName");
          let insertBom = row.map((i, e) => {
            const obj = {
              childId: i.id,
              1003001: i.itemNumber,
              itemId: this.itemInfo.id,
              1003003: i.quantity,
            };
            if (systemName.indexOf('奥斯汀') != -1) {
              Object.assign(obj, { '1003078': i.department.join(';') })
            }
            if (systemName.indexOf('帝京') != -1) {
              Object.assign(obj, { '1003002': (e + 1 + this.gridOptions.data.length), '1003007': 1 })
            }
            return obj
          });

          var updateBomData = {
            //post更改的值
            tableId: this.Global.redLineBomTableId,
            changeObjId: { ...this.objId },
            itemObjId: {
              id: this.itemInfo.id,
              classId: this.itemInfo.classId,
              subClassId: this.itemInfo.subClassId,
              version: this.itemInfo.version,
            },
            insertBom: insertBom,
          };


          axios
            .post("/pmdm/items/saveTable", updateBomData)
            .then(res => {
              if (res.data.code == 200) {
                this.$message({
                  message: res.data.message,
                  type: "success",
                });
                this.$emit('reloadPage')
                this.getData();
                this.closeCreateNew();
               
                // this.searchAddRedLine = false;

              }
            })
            .catch(function (error) {
            });
        }
      }
    },
    addTechnologyRedLineList(row) {
      let insertBom = row.map((i) => {
        return {
          childId: i.id,
          5013002: i.itemNumber,
          technologyId: this.itemInfo.id,
        };
      });
      var updateBomData = {
        tableId: 81,
        changeObjId: { ...this.objId },
        technologyObjId: {
          id: this.itemInfo.id,
          classId: this.itemInfo.classId,
          subClassId: this.itemInfo.subClassId,
          version: this.itemInfo.version,
        },
        insertBom: insertBom,
      };

      axios
        .post("/pmdm/technology/saveTable", updateBomData)
        .then(res => {
          if (res.data.code == 200) {
            this.$message({
              message: res.data.message,
              type: "success",
            });
            this.$emit('reloadPage')
            this.getData();
            this.closeCreateNew();
          }
        })
        .catch(function (error) {
        });
    },
    redLineBomCloseSave() {
      let systemName = window.sessionStorage.getItem("systemName");
      if (systemName.indexOf("奥斯汀") != -1) {
      } else {
        this.$refs.xGrid.revertData(); //清除所有保存，删除，添加记录  会使getUpdateRecords（）拿不到正确的值。奥斯汀判断必填项会出错
      }
    },
    addNewData(dialogName) {
      if (this.pageChanged) {
        this.saveConfirm();
        return
      }
      this[dialogName] = true
    },
    removeRedLineRow() {
      if (this.pageChanged) {
        this.saveConfirm();
        return
      }
      var change_info = this.change_info;
      var removeRow = this.$refs.xGrid.getCheckboxRecords();
      var del_table = [];

      if (removeRow.length == 0) {
        return false;
      }
      {
        this.$confirm(this.$t("message.confirm.deleteData"))
          .then((_) => {
            for (var i = 0; i < removeRow.length; i++) {
              if (removeRow[i].disable) {
                this.$message.error(this.$t("message.error.deleteData"));
                return false;
              } else {
                var obj = {};
                obj.id = removeRow[i].rowId;
                obj.parentRowId = removeRow[i].parentRowId;
                obj.redlineType = removeRow[i].redlineType;
                del_table.push(obj);
              }
            }
            var delBomData = {};
            const objDeleteIdList =
              this.objId.classId == 10410
                ? {
                  title: "technologyObjId",
                  url: "/pmdm/technology/deleteTable",
                }
                : { title: "itemObjId", url: "/pmdm/items/deleteTable" };
            delBomData = {
              tableId:
                this.objId.classId == 10410
                  ? 81
                  : this.Global.redLineBomTableId,
              changeObjId: {
                ...this.objId,
              },
              [objDeleteIdList.title]: {
                id: this.itemInfo.id,
                classId: this.itemInfo.classId,
                subClassId: this.itemInfo.subClassId,
                version: this.itemInfo.version,
              },
              deleteBom: del_table,
            };
            axios
              .post(objDeleteIdList.url, delBomData)
              .then(res => {
                if (res.data.code == 200) {
                  this.$message({
                    message: res.data.message,
                    type: "success",
                  });
                  this.$emit('reloadPage')
                  this.getData();
                }
              })
              .catch(function (error) {
              });
          })
          .catch((_) => { });
      }
    },
    unDoRedLineRow() {
      var change_info = this.change_info;
      var removeRow = this.$refs.xGrid.getCheckboxRecords();
      var del_table = [];

      if (removeRow.length == 0) {
        return false;
      } else {
        this.$confirm(this.$t("message.confirm.unDoData"))
          .then((_) => {
            for (var i = 0; i < removeRow.length; i++) {
              if (!removeRow[i].redlineType) {
                this.$message.error(this.$t("message.error.unDoData"));
                return false;
              } else {
                var obj = {};
                obj.id = removeRow[i].rowId;
                obj.parentRowId = removeRow[i].parentRowId;
                obj.redlineType = removeRow[i].redlineType;
                del_table.push(obj);
              }
            }
            const objUnDoIdList =
              this.objId.classId == 10410
                ? {
                  title: "technologyObjId",
                  url: "/pmdm/technology/undoTable",
                }
                : { title: "itemObjId", url: "/pmdm/items/undoTable" };
            var delBomData = {
              tableId:
                this.objId.classId == 10410
                  ? 81
                  : this.Global.redLineBomTableId,
              changeObjId: {
                ...this.objId,
              },
              [objUnDoIdList.title]: {
                id: this.itemInfo.id,
                classId: this.itemInfo.classId,
                subClassId: this.itemInfo.subClassId,
                version: this.itemInfo.version,
              },
              deleteBom: del_table,
            };
            axios
              .post(objUnDoIdList.url, delBomData)
              .then(res => {
                if (res.data.code == 200) {
                  this.$message({
                    message: res.data.message,
                    type: "success",
                  });
                  this.$emit('reloadPage')
                  this.getData();
                }
              })
              .catch(function (error) {
              });
          })
          .catch((_) => { });
      }
    },
    readLineUpdate() {
      // 奥斯汀的特殊处理
      // 下面包括两部分：
      // 一部分是数量和生产单位不能为空，以后会开发BOM表的字段必填标准功能，这部分以后会去掉
      // 第二部分是替代组和替代关系的问题，要么都为空，要么都有值，这部分以后要一直保留
      let systemName = window.sessionStorage.getItem("systemName");

      if (systemName.indexOf("奥斯汀") != -1) {
        // 数量和生产单位不能为空
        let quantity = 0;
        let proUnit = 0;
        for (let k = 0; k < this.gridOptions.columns.length; k++) {
          if (this.gridOptions.columns[k].attid == this.Constants.itemBOMQty) {
            quantity = this.gridOptions.columns[k].field;
          }
          if (
            this.gridOptions.columns[k].attid ==
            this.Constants.itemBOMMultilist01
          ) {
            proUnit = this.gridOptions.columns[k].field;
          }
        }

        let allRows = this.$refs.xGrid.data;
        for (let i = 0; i < allRows.length; i++) {
          let oneRow = allRows[i];
          if (oneRow.disable) continue;
          if (oneRow[quantity] == "" || oneRow[quantity] == null) {
            this.$message.error(this.$t("message.warning.blankRequired"));
            return false;
          }
          if (oneRow[proUnit] == "" || oneRow[proUnit] == null) {
            this.$message.error(this.$t("message.warning.blankRequired"));
            return false;
          }
        }
        let updateRecords = this.$refs.xGrid.getUpdateRecords();
        if (
          updateRecords[proUnit] != null &&
          updateRecords[0] != null &&
          updateRecords[0][proUnit].length == 0
        ) {
          this.$message.error(this.$t("message.warning.blankRequired"));
          return false;
        }

        //替代组和替代关系的问题，要么都为空，要么都有值
        let substitutionalRelation = 0;
        let substituteTissue = 0;
        for (let k = 0; k < this.gridOptions.columns.length; k++) {
          if (
            this.gridOptions.columns[k].attid == this.Constants.itemBOMList02
          ) {
            substitutionalRelation = this.gridOptions.columns[k].field;
          }
          if (
            this.gridOptions.columns[k].attid == this.Constants.itemBOMList01
          ) {
            substituteTissue = this.gridOptions.columns[k].field;
          }
        }
        for (let i = 0; i < allRows.length; i++) {
          let oneRow = allRows[i];
          if (!oneRow.rowId) {
            continue;
          }
          let subRelValue = oneRow[substitutionalRelation];
          let subTisValue = oneRow[substituteTissue];
          let subRelValueBlank = subRelValue == null || subRelValue == "";
          let subTisValueBlank = subTisValue == null || subTisValue == "";
          // if((subRelValueBlank && !subTisValueBlank)
          // ||(!subRelValueBlank && subTisValueBlank)){
          if (subRelValueBlank != subTisValueBlank) {
            this.$message.error(
              this.$t("message.warning.substituteTissueRelNotOneBlank")
            );
            return false;
          }
        }
      }

      var xGrid_ = this.$refs.xGrid;
      let updateRecords = xGrid_.getUpdateRecords(); //获取修改的行
      console.log(updateRecords);

      var updateBom = [];
      if (updateRecords.length !== 0) {
        //判断行内那些值有改动
        for (let i = 0; i < updateRecords.length; i++) {
          var num = xGrid_.getRowIndex(updateRecords[i]);
          var cols_length = this.cols;
          for (let j = 0; j < cols_length.length; j++) {
            var updateNewData = xGrid_.isUpdateByRow(updateRecords[i], "" + j);
            if (updateNewData) {
              for (let k = 0; k < this.gridOptions.columns.length; k++) {
                var obj = {};
                obj.redlineType = updateRecords[i].redlineType;
                if (cols_length[j] == this.gridOptions.columns[k].attid) {
                  var quantity = cols_length[j];
                  obj.id = updateRecords[i].rowId;
                  if (this.gridOptions.columns[k].editRender.props) {
                    //处理多选和单选
                    if (this.gridOptions.columns[k].editRender.props.multiple) {
                      obj[quantity] = updateRecords[i][j].join(";");
                    } else if (
                      this.gridOptions.columns[k].editRender.props.type ==
                      "datetime"
                    ) {
                      // obj[quantity] = updateRecords[i][j].format("yyyy-MM-ddThh:mm:ss");
                      obj[quantity] = this.format(
                        updateRecords[i][j],
                        "yyyy-MM-ddThh:mm:ss"
                      );
                    } else {
                      obj[quantity] = updateRecords[i][j] ?? "";
                    }
                  } else {
                    obj[quantity] = updateRecords[i][j] ?? "";
                  }
                  updateBom.push(obj);
                }
              }
            }
          }
        }
        const objUpdateIdList =
          this.objId.classId == 10410
            ? { title: "technologyObjId", url: "/pmdm/technology/updateTable" }
            : { title: "itemObjId", url: "/pmdm/items/updateTable" };
        var updateBomData = {
          tableId:
            this.objId.classId == 10410
              ? 81
              : this.Global.redLineBomTableId,
          changeObjId: { ...this.objId },
          [objUpdateIdList.title]: {
            id: this.itemInfo.id,
            classId: this.itemInfo.classId,
            subClassId: this.itemInfo.subClassId,
            version: this.itemInfo.version,
          },
          updateBom: this.arrGroup(updateBom),
        };

        axios
          .post(objUpdateIdList.url, updateBomData)
          .then(res => {
            if (res.data.code == 200) {
              this.$message({
                message: res.data.message,
                type: "success",
              });
              this.$emit('reloadPage')
              this.getData();
              this.setPageChanged({ name: this.componentname, isChanged: false })
            }
          })
          .catch(function (error) {
          }).finally(_ => {

          })
      } else {
        this.setPageChanged({ name: this.componentname, isChanged: false })
        this.$message({
          message: this.$t("message.error.noChange"),
          type: "warning",
        });
        // alert(this.$t('message.error.save'))
      }
    },
  }
}
</script>
<style lang="scss" scoped></style>